import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './api/apiSlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import authReducer from '../features/auth/authSlice';
import snackReducer from '../features/snack-bar/snackSlice';
import dialogReducer from '../features/dialog/dialogSlice';
import userSettingsSlice from '../features/settings/userSettingsSlice';

const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, authReducer)

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [userSettingsSlice.reducerPath]: userSettingsSlice.reducer,
    auth: persistedReducer,
    snack: snackReducer,
    dialog: dialogReducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store)